import { render, staticRenderFns } from "./CustomerCenterList.vue?vue&type=template&id=2f2a5099&scoped=true"
import script from "./CustomerCenterList.vue?vue&type=script&lang=js"
export * from "./CustomerCenterList.vue?vue&type=script&lang=js"
import style0 from "./CustomerCenterList.vue?vue&type=style&index=0&id=2f2a5099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a5099",
  null
  
)

export default component.exports